import { Tooltip } from 'antd';

export function CellRequiredFieldIndicator() {
  const color = '#780650';
  return (
    <Tooltip title="Zorunlu alan">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: color,
          height: '1rem',
          paddingLeft: '3px',
          paddingRight: '3px',
          margin: '0 2px',
          color: '#ffffff',
          fontSize: '0.6rem',
          fontWeight: 'bold',
        }}
      >
        1
      </div>
    </Tooltip>
  );
}
